export default {
    map: null,
    markers: [],
    markersInterval: null,

    init() {
        clearInterval(this.markersInterval);
        if (!$("#location-map").length) return;

        this.map = L.map("location-map").setView([52.2297, 21.0122], 13);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "",
        }).addTo(this.map);
        this.markers = [];
        this.fetchMarkers();
        this.markersInterval = setInterval(() => this.fetchMarkers(), 10000);
    },

    fetchMarkers() {
        $.ajax({
            url: "/location/location/get-markers",
            method: "GET",
            dataType: "json",
        })
            .done((data) => {
                this.markers.forEach((marker) => this.map.removeLayer(marker));
                this.markers = [];
                const group = L.featureGroup();

                data.forEach((item) => {
                    const marker = L.marker([item.lat, item.lon]).addTo(this.map);
                    marker
                        .bindPopup(`${item.name}<br />${item.date}`, { autoClose: false })
                        .openPopup();
                    this.markers.push(marker);
                    group.addLayer(marker);
                });

                if (data.length) this.map.fitBounds(group.getBounds().pad(0.1));
            })
            .fail((error) => console.error("Błąd pobierania markerów", error));
    },
};
